import React, { useEffect } from 'react';
import M from 'materialize-css';
import quotes from '../data/quotes';

const QuoteCarousel = () => {
  useEffect(() => {
    // Initialize Materialize Carousel
    const carouselElement = document.querySelector('.carousel');
    const carouselInstance = M.Carousel.init(carouselElement, {
      fullWidth: true,
      indicators: true,
      duration: 500
    });

    // Auto-rotate quotes
    const interval = setInterval(() => {
      carouselInstance.next();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="section quote-carousel-section">
      <div className="carousel carousel-slider center">
        {quotes.map((quote) => (
          <div
            key={quote.id}
            className="carousel-item white-text neon-card"
            style={{
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '80px'
            }}
          >
            <div className="container" style={{ maxWidth: '90%' }}>
              <blockquote style={{ fontSize: '1.3rem', margin: 0, lineHeight: '1.2' }}>
                "{quote.text}"
              </blockquote>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuoteCarousel;
